import { LuUsers, LuShoppingCart, LuPackage, LuWarehouse, LuCalculator, LuUserCheck, LuFactory } from "react-icons/lu";

export const MODULES = [
  {
    name: "CRM",
    description: "Manage leads, contacts & pipelines",
    icon: LuUsers,
    bg: "rgba(108,99,255,0.1)",
    color: "#6C63FF",
  },
  {
    name: "Sales",
    description: "Quotes, orders & invoicing",
    icon: LuShoppingCart,
    bg: "rgba(59,130,246,0.1)",
    color: "#3b82f6",
  },
  {
    name: "Purchases",
    description: "Supplier orders & procurement",
    icon: LuPackage,
    bg: "rgba(245,158,11,0.1)",
    color: "#f59e0b",
  },
  {
    name: "Inventory",
    description: "Stock, warehouses & transfers",
    icon: LuWarehouse,
    bg: "rgba(20,184,166,0.1)",
    color: "#14b8a6",
  },
  {
    name: "Production",
    description: "Bills of materials & production orders",
    icon: LuFactory,
    bg: "rgba(108,99,255,0.1)",
    color: "#6C63FF",
  },
  {
    name: "Accounting",
    description: "Ledgers, taxes & financial reports",
    icon: LuCalculator,
    bg: "rgba(34,197,94,0.1)",
    color: "#22c55e",
  },
  {
    name: "HR",
    description: "Employees, payroll & attendance",
    icon: LuUserCheck,
    bg: "rgba(236,72,153,0.1)",
    color: "#ec4899",
  },
];